'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'briefcase';
var width = 512;
var height = 512;
var aliases = [128188];
var unicode = 'f0b1';
var svgPathData = ['M32 160l0 96 448 0 0-96c0-17.7-14.3-32-32-32L64 128c-17.7 0-32 14.3-32 32zm0 128l0 128c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-128-144 0 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48-144 0z', 'M192 48l0 48 128 0 0-48c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zM160 96l0-48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 48 96 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l96 0zm176 32L64 128c-17.7 0-32 14.3-32 32l0 96 448 0 0-96c0-17.7-14.3-32-32-32l-112 0zM480 288l-144 0 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48-144 0 0 128c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-128zm-272 0l0 48 96 0 0-48-96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBriefcase = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;